import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { catchError, mergeMap, of, switchMap, withLatestFrom } from "rxjs";
import { downloadFile } from "src/app/core/helpers";
import { selectData } from "..";
import { GenericApiService } from "../../services";
import { appEventActions } from "../app-event";
import { lovsActions } from "./lovs.action";

@Injectable()
export class LovsEffects {
    constructor(
        private actions$: Actions,
        private genericApiService: GenericApiService,
        private store: Store,
    ) {}

    getLovsData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(lovsActions.getLovData),
            withLatestFrom(this.store.select(selectData)),
            mergeMap(([data, values]) => {
                if (!data?.data?.skipCache && values[data.data.url]) {
                    return of(lovsActions.setLovData({ data: values[data.data.url], key: data.data.url }));
                }
                this.store.dispatch(lovsActions.toggleLoadingState({ key: data.data.url }));
                return this.genericApiService.getAll(data.data).pipe(
                    mergeMap((res) => {
                        return of(
                            lovsActions.setLovData({
                                data: res,
                                key: data.data.url,
                            }),
                            lovsActions.toggleLoadingState({ key: data.data.url }),
                        );
                    }),
                    catchError((err) => {
                        this.store.dispatch(lovsActions.toggleLoadingState({ key: data.data.url }));
                        return of(appEventActions.handleError(err));
                    }),
                );
            }),
        ),
    );

    downloadSampleExcelFile$ = createEffect(() =>
        this.actions$.pipe(
            ofType(lovsActions.downloadSampleExcelFile),
            switchMap((data) => {
                return this.genericApiService.downloadSampleExcel(data.data.url).pipe(
                    switchMap((resp) => {
                        downloadFile(
                            typeof resp === "string" ? resp : resp.file,
                            data.data.fileName || "sample-file.xlsx",
                        );
                        if (data.onSuccess) {
                            data.onSuccess();
                        }
                        return of(appEventActions.emptyAction());
                    }),
                    catchError((err) => {
                        if (data.onSuccess) {
                            data.onSuccess();
                        }
                        return of(appEventActions.handleError(err));
                    }),
                );
            }),
        ),
    );

    uploadSampleExcelFile$ = createEffect(() =>
        this.actions$.pipe(
            ofType(lovsActions.uploadSampleExcelFile),
            switchMap((payload) =>
                this.genericApiService.uploadStudentsExcel(payload.data.data, payload.data.url).pipe(
                    switchMap(() => {
                        payload.data.onClose(true);
                        return of(
                            appEventActions.addToast({
                                detail: "Data imported successfully",
                                severity: "success",
                            }),
                        );
                    }),
                    catchError((err) => {
                        return of(appEventActions.handleError(err));
                    }),
                ),
            ),
        ),
    );
}
